var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"overflow-hidden fill-height"},_vm._l((_vm.total),function(n){return _c('v-skeleton-loader',{key:n,attrs:{"type":_vm.type,"boilerplate":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }